<template>
  <div v-loading="isLoading" class="data-down">
    <div class="data-overall-Single">
      <div>
        <el-form ref="formSingle" :model="form" class="release-form" :inline="true">
          <el-form-item label="发布来源:" class="release-label">
            <el-cascader
              v-model="form.source"
              :options="sourceOptions"
              clearable
              filterable
              :props="{ checkStrictly: true }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="文章标签:" class="release-label">
            <el-select v-model="form.product_ids" clearable multiple placeholder="请选择">
              <el-option
                v-for="item in articleTabOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="文章名:" class="release-label">
            <el-input
              v-model="form.article_name"
              class="release-input"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item label="选择日期:" class="release-label">
            <el-date-picker
              v-model="form.date"
              :unlink-panels="true"
              type="daterange"
              :editable="false"
              value-format="yyyy-M-d"
              class="release-select-time"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="button-group">
        <el-button type="primary" @click="onSubmitSingle">筛选</el-button>
        <ExportProgress ref="downloadDialog"></ExportProgress>
        <ExportExcel
          :config-name="$options.name"
          :excel-data="excelData"
          :is-loading="isExportLoading"
          @emit="handleExportExcel"
        ></ExportExcel>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <template slot="empty">
        <NoData></NoData>
      </template>
      <el-table-column prop="article_name" label="文章名称" width="180" />
      <el-table-column prop="art_id" label="文章ID" width="100" />
      <el-table-column prop="publish_date" label="发布时间" width="180"></el-table-column>
      <el-table-column prop="appname" label="渠道" />
      <el-table-column prop="read_count" label="阅读次数" />
      <el-table-column prop="read_pnt" label="阅读人数" />
      <el-table-column prop="share_count" label="分享次数" />
      <el-table-column prop="collect_count" label="收藏次数" />
      <el-table-column prop="read_duration" label="阅读时长(min)">
        <template slot-scope="scope">
          {{ formatSecondsToMin(Number(scope.row.read_duration)) }}
        </template>
      </el-table-column>
      <el-table-column prop="finish_rate" label="阅读完成率">
        <template slot-scope="scope">
          {{ scope.row.finish_rate ? `${Number(scope.row.finish_rate).toFixed(2)}%` : '--' }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      style="background-color: #ffffff"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="g_pageSizesConfig"
      :total="total"
      :page-size="pageParams.page_size"
      :current-page="pageParams.page_index"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>
<script>
import { dateFormat } from '@/utils/time.js';
import { getArticleStatDetailApi } from '@/api/dataCenter';
import { GetProductInfoList } from '@/api/setUser';
import NoData from '@/components/no-data';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';
export default {
  name: 'ArticalDataDetailByOneDay',
  components: {
    NoData,
    ExportExcel,
    ExportProgress,
  },
  props: {
    sourceOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      form: {
        source: [], // 发布账号
        date: null, // 查询时间
        article_name: '',
        product_ids: [],
      },
      tableData: [],
      pageParams: {
        page_index: 1,
        page_size: this.g_pageSizeDefault,
      },
      total: 0, // 总页数
      articleTabOptions: [],
      excelData: [],
      isExportLoading: false,
    };
  },
  beforeMount() {},
  created() {
    this.pageParams.page_size = this.g_pageSizeDefault;
    this.getLabelInfoList();
    this.getList();
  },
  methods: {
    async getLabelInfoList() {
      try {
        // const params = {
        //   label_type: 10, // 产品推广下的全量标签
        //   page_index: 1,
        //   page_size: 9999,
        // };
        const res = await GetProductInfoList();
        // console.log(111, res);
        this.articleTabOptions = res.list.map((item) => ({
          label: item.product_name,
          value: item.id,
        }));
      } catch (err) {}
    },
    async getList() {
      this.isLoading = true;
      const params = {
        source: this.form.source.length >= 1 ? this.form.source[0] : 0, // 渠道， 1-公众号，2-小程序
        appid: this.form.source.length >= 2 ? this.form.source[1] : '',
        ...this.pageParams,
        start_date: this.form.date ? dateFormat(new Date(this.form.date[0]), 'YYYY-MM-dd') : '',
        end_date: this.form.date ? dateFormat(new Date(this.form.date[1]), 'YYYY-MM-dd') : '',
        // start_date: '2020-02-02',
        // end_date: '2021-05-05',
        article_name: this.form.article_name,
        product_ids: this.form.product_ids,
      };
      try {
        const res = await getArticleStatDetailApi(params);
        // console.log(res, 666);
        this.tableData = res.data;
        this.total = res.total_num;
      } catch (err) {
        console.log('err', err);
        this.tableData = [];
        this.total = 0;
        this.$message.error(`查询文章明细数据失败 ${err.message || ''}`);
      }
      this.isLoading = false;
    },
    async handleExportExcel() {
      this.isExportLoading = true;
      this.$refs.downloadDialog.openDialog();
      this.$refs.downloadDialog.startRidiculousProgress(30);
      const params = {
        source: this.form.source.length >= 1 ? this.form.source[0] : 0, // 渠道， 1-公众号，2-小程序
        appid: this.form.source.length >= 2 ? this.form.source[1] : '',
        start_date: this.form.date ? dateFormat(new Date(this.form.date[0]), 'YYYY-MM-dd') : '',
        end_date: this.form.date ? dateFormat(new Date(this.form.date[1]), 'YYYY-MM-dd') : '',
        article_name: this.form.article_name,
        product_ids: this.form.product_ids,
      };
      try {
        const res = await getArticleStatDetailApi({
          page_index: 1,
          page_size: 1,
          ...params,
        });
        if (res.total_num > 50000) {
          this.$message.warning(`最大支持导出5万条数据，当前数据${res.total_num}条，请重新筛选`);
          this.$refs.downloadDialog.abortProgress();
          this.isExportLoading = false;
        } else {
          const res = await getArticleStatDetailApi({
            page_index: 1,
            page_size: 50000,
            ...params,
          });
          this.excelData = res.data.map((item) => {
            const items = { ...item };
            items.read_duration = this.formatSecondsToMin(Number(item.read_duration));
            items.finish_rate = item.finish_rate ? `${Number(item.finish_rate).toFixed(2)}%` : '--';
            return items;
          });
          this.$refs.downloadDialog.finishProgress(500);
        }
      } catch (err) {
        this.$refs.downloadDialog.abortProgress();
        console.log('err', err);
      }
      this.isExportLoading = false;
    },
    formatSecondsToMin(seconds) {
      if (!seconds) return '-';
      const min = parseInt(seconds / 60, 10);
      const s = seconds % 60;
      return `${min ? `${min}min` : ''} ${s ? `${s}s` : ''}`;
    },
    // 筛选
    onSubmitSingle() {
      this.pageParams.page_index = 1;
      this.getList();
    },
    // 选择页
    handleCurrentChange(val) {
      this.pageParams.page_index = val;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageParams.page_size = size;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.data-down {
  .data-overall-Single {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .button-group {
      margin-bottom: 22px;
    }
  }

  .pagination {
    float: right;
    margin-top: 12px;
  }
}
</style>
<style lang="scss">
// .article-tabs-cascader {
//   .el-cascader-panel {
//     & > div:first-child {
//       .el-checkbox {
//         display: none !important;
//       }
//     }
//   }
// }
</style>
